import { render, staticRenderFns } from "./StepComponent.vue?vue&type=template&id=592c6478&"
import script from "./StepComponent.vue?vue&type=script&lang=js&"
export * from "./StepComponent.vue?vue&type=script&lang=js&"
import style0 from "./StepComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports